import Home04 from './Home04';

const routes = [
    { path: "/", component: <Home04 /> },
]

export default routes;